export type AdminPurchasingResponse = {
  filters: {
    query: string;
    threshold: number;
    supplierId: number | null;
  };
  summary: {
    lowStockProducts: number;
    mappedProducts: number;
    sourcingGaps: number;
    supplierLines: number;
    estimatedTotal: number;
  };
  suppliers: Array<{
    id: number;
    name: string;
    contact: string;
  }>;
  candidates: Array<{
    id: number;
    name: string;
    slug: string;
    quantity: number;
    price: number;
    category: string;
    supplierLinks: number;
  }>;
  supplierOrder: Array<{
    id: number;
    inventoryId: number | null;
    inventoryName: string;
    inventorySlug: string | null;
    currentStock: number;
    supplierName: string;
    supplierProductName: string;
    sku: string;
    unitPrice: number;
    orderQuantity: number;
    total: number;
  }>;
  sourcingGaps: Array<{
    id: number;
    name: string;
    slug: string;
    quantity: number;
    category: string;
    supplierLinks: number;
  }>;
};

async function parseResponse(response: Response) {
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(data?.message || `Request failed: ${response.status}`);
  }

  return data;
}

export async function fetchAdminPurchasing(query: URLSearchParams) {
  const response = await fetch(`/api/admin/purchasing?${query.toString()}`, {
    credentials: "include",
    headers: {
      Accept: "application/json"
    }
  });

  return (await parseResponse(response)) as AdminPurchasingResponse;
}
